import {Component} from "@angular/core";
import {DOCUMENT_TYPES} from "../../enums/enums";
import {BusService} from "../../services/bus.service";
import {paramsHelper} from "../../helpers/params-helper";
import {UI_TEXTS} from "../../enums/e-texts";
import {VALUE_TYPE} from "../../enums/enums";
import {SEARCH_PROP_TYPES} from "../../enums/e-search";
import {IAchievement} from "../../interfaces/achievement.definition";
import {localeUtils} from "../../helpers/locale-utils";


@Component({
  templateUrl: "./achievements-page.component.html"
})
export class AchievementsPageComponent {
  UI_TEXTS = UI_TEXTS;
  VAL_TYPES = VALUE_TYPE;
  pageParams = paramsHelper.page()
    .setTitle("Ачивки");

  collectionParams = paramsHelper.collection()
    .setObjectType(DOCUMENT_TYPES.ACHIEVEMENT)
    .setListLabels("Название", "%/name%") // todo: remove this
    .setItemLabelQuery(`locales.${localeUtils.getLocale()}.[key=name].value.0`)
    .setSearchParams(paramsHelper.search()
      .addParam(`locales.${localeUtils.getLocale()}.name`, SEARCH_PROP_TYPES.LOCALE, "")
      .addNumberParam("id")/*
     .addStringParam("name")*/);

  document: IAchievement;


  constructor(private busService: BusService) {
    this.busService.onDocumentUpdated
      .subscribe(
        e => this.document = <IAchievement>e.document);
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/pages/achievements/achievements-page.component.ts